let React = require("ES/lib/react");

export default  function(props){
	let name = props.name;
	let value = props.value;
	let checked = props.checked;
	let onChange = props.onChange;
	return <div className="radio">
		<label>
			<input type="radio" name={name} value={value} checked={checked} onChange={onChange} />
			{props.children}
		</label>
	</div>;
}



// WEBPACK FOOTER //
// ./src/components/inputs/Radio.js